import { ApiConfig } from '../../widget-context.type';

export const GetHeaders = (apiConfig: ApiConfig): { [key: string]: string } => {
  if (apiConfig) {
    if (apiConfig?.defaultHeaders) {
      const tempHeader = {};
      Object.assign(tempHeader, apiConfig.defaultHeaders);

      return tempHeader;
    } else {
      return {};
    }
  } else {
    throw Error('Host data not defined');
  }
};

/**
 * Function to return full URL.
 *
 * @todo Should we guard against undefined values?
 * @param domain The domain of the URL.
 * @param url The base URL.
 * @param suffix The optional suffix to be appended to the URL.
 * @param [urlObj] An optional URL object containing key-value pairs to be inserted into the URL.
 * @returns The full URL with the domain, base URL, optional suffix, and inserted key-value pairs from the URL object.
 *
 * @example
 * ```javascript
 * const fullURL = GetFullURL('example.com', '/api/users', '?page=2', { 'id': '123' });
 * console.log(fullURL);  // Outputs: http://example.com/api/users?id=123&page=2
 * ```
 */
export const GetFullURL = (domain: string, url: string, suffix: string, urlObj?: { [header: string]: string }): string => {
  let fullURL = url;
  if (!domain) {
    throw Error('Host data not defined');
  }

  if (urlObj !== undefined) {
    for (const key in urlObj) {
      if (urlObj.hasOwnProperty(key)) {
        const element: string = urlObj[key];
        // we dont guard against element being `undefined`
        if (fullURL.indexOf(`{${key}}`) > 0) {
          fullURL = fullURL.replaceAll(`\{${key}\}`, element);
        }
      }
    }
  }

  fullURL = fullURL ? `/${fullURL}` : fullURL;
  suffix = suffix ? `/${suffix}` : '';
  return `${domain}${suffix}${fullURL}`;
};
